import { OnChanges, OnInit, OnDestroy, SimpleChanges, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';
import * as fileSaver from 'file-saver';
import 'rxjs/add/operator/first';

import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column';

export abstract class TabComponentBase<T extends Slick.SlickData, T2 extends { columns: { header: string, field: string }[] }> implements OnChanges, OnInit, AfterViewInit, OnDestroy {
    protected constructor(protected readonly graphService: BufferGraphService) {
        
    }

    protected abstract gridRef: SlickGridComponent;

    protected abstract sku: string;

    protected abstract warehouseCode: string;

    protected abstract canSend: boolean;

    protected abstract isActive: boolean;

    protected readonly alertTime = 10000;

    protected dataView: Slick.Data.DataView<T>;

    protected columns: ISlickGridColumn<T>[];

    protected options: Slick.GridOptions<T>;

    protected showExportError: boolean;

    protected showExportErrorTimer: any;

    protected showSendError: boolean;

    protected showSendErrorTimer: any;

    protected showSendSuccess: boolean;

    protected showSendSuccessTimer: any;

    protected sending: boolean;

    protected exporting: boolean;

    protected destroyed: boolean;

    protected resizeOnActivation: boolean;

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.resizeOnActivation || !changes['isActive'])
            return;

        setTimeout(() => this.onTabsResized(), 1);
        this.resizeOnActivation = false;
    }

    ngOnInit(): void {
        this.graphService.onTabsResized.takeWhile(() => !this.destroyed).subscribe(()=>this.onTabsResized());
    }

    ngAfterViewInit(): void {
        this.onTabsResized();
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    protected onTabsResized(): boolean {
        if (!this.isActive) {
            this.resizeOnActivation = true;
            return false;
        }

        if (this.gridRef)
            this.gridRef.resizeGrid();

        return true;
    }

    protected sendToEmail = (makeRequest: (data: T2) => Observable<{ success: boolean }>): void => {
        this.export(true, makeRequest, null);
    }

    protected download = (makeRequest: (data: T2) => Observable<{ fileContent: Blob, fileName: string }>): void => {
        this.export(false, null, makeRequest);
    }

    protected abstract getExportData: () => T2;

    protected getExportDataByDefault = (): { columns: { header: string, field: string }[], rows: string[][] } => {
        const columns = this.gridRef.getColumns().map(c => { return { header: c.name, field: c.field }; });
        const rows = [];

        const length = this.dataView.getLength();
        for (let i = 0; i < length; i++) {
            const changeHistory = this.dataView.getItemByIdx(i);

            const row = [];
            columns.forEach(c => {
                const val = changeHistory[c.field];
                if (moment.isMoment(val))
                    row.push(val.toJSON());
                else
                    row.push(val == null ? '' : `${val}`);

            });
            rows.push(row);
        }

        return { columns, rows };
    }

    private export = (toEmail: boolean, emailRequest: (data: T2) => Observable<{ success: boolean }>, downloadRequest: (data: T2) => Observable<{ fileContent: Blob, fileName: string }>): void => {
        if (toEmail)
            this.sending = true;
        else
            this.exporting = true;

        //const columns = this.gridRef.getColumns().map(c => { return { header: c.name, field: c.field }; });
        //const rows = [];

        //const length = this.dataView.getLength();
        //for (let i = 0; i < length; i++) {
        //    const changeHistory = this.dataView.getItemByIdx(i);

        //    const row = [];
        //    columns.forEach(c => {
        //        const val = changeHistory[c.field];
        //        if (moment.isMoment(val))
        //            row.push(val.toJSON());
        //        else
        //            row.push(`${val == null ? '' : val}`);

        //    });
        //    rows.push(row);
        //}
        const showError = (): void => {
            if (toEmail) {
                this.showExportError = false;
                this.showSendSuccess = false;

                if (this.showSendErrorTimer)
                    clearTimeout(this.showSendErrorTimer);

                this.showSendError = true;
                setTimeout(() => {
                    this.showSendError = false;
                    clearTimeout(this.showSendErrorTimer);
                },
                    this.alertTime);
                return;
            }

            this.showSendError = false;
            this.showSendSuccess = false;

            if (this.showExportErrorTimer)
                clearTimeout(this.showExportErrorTimer);

            this.showExportError = true;
            setTimeout(() => {
                this.showExportError = false;
                clearTimeout(this.showExportErrorTimer);
            },
                this.alertTime);
        };

        if (toEmail) {
            emailRequest(this.getExportData()).first().subscribe((data: { success: boolean }) => {
                this.sending = false;

                if (data && data.success) {
                    if (this.showSendSuccess)
                        clearTimeout(this.showSendSuccessTimer);

                    this.showExportError = false;
                    this.showSendError = false;
                    this.showSendSuccess = true;
                    setTimeout(() => {
                        this.showSendSuccess = false;
                        clearTimeout(this.showSendSuccessTimer);
                    },
                        this.alertTime);
                    return;
                }

                showError();
            }, () => {
                this.sending = false;
                showError();
            });
            return;
        }

        downloadRequest(this.getExportData()).first().subscribe((data: { fileContent: Blob, fileName: string }) => {
            this.exporting = false;
            if (data && data.fileContent && data.fileContent.size > 0) {
                fileSaver.saveAs(data.fileContent, data.fileName);
                return;
            }

            showError();
        },
            () => {
                this.exporting = false;
                showError();
            });
    }

    protected onHideExportErrorClick = (): void => {
        setTimeout(() => this.showExportError = false, 500);
    }

    protected onHideSendErrorClick = (): void => {
        setTimeout(() => this.showSendError = false, 500);
    }

    protected onHideSendSuccessClick = (): void => {
        setTimeout(() => this.showSendSuccess = false, 500);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/tab-component-base.ts